import React, { useState, useEffect } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useHistory } from "react-router-dom";

import OnboardingStepHeader from "./OnboardingStepHeader";
import Sallie from "../Sallie";
import SubmitButton from "../StyledComponents/SubmitButton";

const EmailSent = ({ setOnboardingPercent, user }) => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();

  useEffect(() => {
    setOnboardingPercent(90);
  }, []);

  const clickHandler = () => {
    setSubmitting(true);
    history.push("/");
  };

  let SallieMsg = `${t("onboarding.emailSent.emailSentOne")} ${user.email} ${t("onboarding.emailSent.emailSentTwo")}`;
  return (
    <>
      <OnboardingStepHeader text={t("onboarding.emailSent.header")} />
      <Sallie text={SallieMsg} />
      <SubmitButton
        disabled={submitting}
        onClick={clickHandler}
      >
        {t("onboarding.login")}
      </SubmitButton>
    </>
  );
};

export default EmailSent;